<template>
<div>

    <m-edit-text
        :label="label"
        :value="pretty"
        :custom_on_edit="onClickEdit"
        hint="Date Format: YYYY-MM-DD"
        show_hint_everywhere
        :read_only="read_only"
    />

    <m-edit-instant-dialog
        :title="label"
        :value="value"
        ref="edit-dialog"
        :optional="optional"
        v-on:ok="onSet($event)"
        :timezone="timezone"
    />
</div>
</template>

<script>
import { DateTime } from 'luxon';

export default 
{
    props: {

        value: {
            type: Number,
            default: function() { return null; }
        },

        timezone: {
            type: String,
            default: function() { return 'US/Arizona'; }
        },

        label: {
            type: String,
            default: function() { return 'Time'}
        },

        optional: {
            type: Boolean,
            default: function() { return false; }
        },

        read_only: 
        {
            type: Boolean,
            default: function() { return false; }
        },
    },

    methods: {
        onClickEdit() {
            this.$refs['edit-dialog'].showDialog();
        },

        onSet(millis)
        {
            this.$emit('input', millis);
        }
    },

    computed: {
        pretty() 
        {
            if ( this.value == null ) return null;

            let dt = DateTime.fromMillis(this.value).setZone(this.timezone);

            return dt.toISODate() + ' @ ' + dt.toLocaleString(DateTime.TIME_SIMPLE) + ' ('+this.timezone+')'
        }
    },
}
</script>

<style lang="scss" scoped>

</style>